import {
    JITSI_HANGUP,
    JITSI_MEET,
    JITSI_MEET_ROOM_DETAILS,
    JITSI_REQUEST_AUTO_JOIN,
    JITSI_TOGGLE_CHAT,
    JITSI_VIDEO_CONFERENCE_JOINED,
    JitsiActionTypes,
} from '../../actions/jitsi/types'

export interface JitsiState {
    isActive: boolean;
    isChatOpen: boolean;
    activeVideoChannelId: string;
    pendingAutoJoinChannelId?: string | null;
    jitsi_room?: string | null
    jitsi_token?: string | null
    videoConferenceJoined?: boolean;
}

const defaultState = {
    activeVideoChannelId: '',
    isActive: false,
    isChatOpen: false,
    jitsi_room: null,
    jitsi_token: null,
    pendingAutoJoinChannelId: null,
    videoConferenceJoined: false,
} as JitsiState

const jitsiReducer = (state: JitsiState = defaultState, action: JitsiActionTypes): JitsiState => {
    switch (action.type) {
        case JITSI_HANGUP:
            return defaultState
        case JITSI_MEET: {
            const newState = {
                activeVideoChannelId: action.channel_id,
                isActive: true,
                isChatOpen: false,
                pendingAutoJoinChannelId: null,
            } as JitsiState
            return {
                ...state,
                ...newState,
            }
        }
        case JITSI_REQUEST_AUTO_JOIN:
            return {
                ...state,
                pendingAutoJoinChannelId: action.channel_id,
            }
        case JITSI_MEET_ROOM_DETAILS: {
            const {
                jitsi_token,
                jitsi_room,
            } = action
            return {
                ...state,
                jitsi_room,
                jitsi_token,
            }
        }
        case JITSI_TOGGLE_CHAT:
            return {
                ...state,
                ...{isChatOpen: !state.isChatOpen},
            }
        case JITSI_VIDEO_CONFERENCE_JOINED:
            return {
                ...state,
                ...{videoConferenceJoined: action.joined},
            }
        default:
            return state
    }
}

export {
    jitsiReducer,
}
